// ⚠️ APPLE = IDs App Store Connect (rien à voir avec Stripe)
export const APPLE_PRODUCT_IDS = {
  monthly: "clanpromonthlysubs",
  annual: "clanproannualsubs",
} as const;

// ✅ STRIPE = tes price IDs (inchangés)
export const STRIPE_PRICE_IDS = {
  monthly: "price_1SAmkUKCAuEWvMr88rp0lnFk",
  annual: "price_1SEqKEKCAuEWvMr82B0QdqfS",
} as const;
